import { useState, useContext, useEffect } from "react";
import {
  Avatar,
  Box,
  Typography,
  Paper,
  Grid,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import Navigation from "../components/NavBars/Navigation";
import SnackbarComponent from "../components/Alerts/SnackbarComponent";
import { updateProfile } from "../components/Helper";
import { AuthContext } from "../components/Auth/Auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const SCHOOL_OPTIONS = [
  "Secacus High School",
  "Lincoln High School",
  "Roundpier"
];

const StudentProfile = () => {
  const { currentUser } = useContext(AuthContext);

  const allItems = Object.fromEntries(
    Object.keys(localStorage).map(key => [key, localStorage.getItem(key)])
  );

  console.log("localStorage all profile", allItems);

  const [schoolName, setSchoolName] = useState("");
  const [name, setName] = useState("");
  const [initialName, setInitialName] = useState("");
  const [initialSchoolName, setInitialSchoolName] = useState("");

  const [editing, setEditing] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [severity, setSeverity] = useState("success");

  useEffect(() => {
    const fetchUserData = async () => {
      if (currentUser?.uid) {
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          const name = data.name || currentUser.name || "";
          const school = data.schoolName || "";
          setName(name);
          setSchoolName(school);
          setInitialName(name);
          setInitialSchoolName(school);
        }
      }
    };
    fetchUserData();
  }, [currentUser]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMsg("");
    setSeverity("success");
  };

  const handleUpdate = async () => {
    try {
      await updateProfile(currentUser.uid, { name, schoolName });
      setSnackbarMsg("Profile updated successfully.");
      setSeverity("success");
      setSnackbarOpen(true);
      setEditing(false);
      setInitialName(name);
      setInitialSchoolName(schoolName);
    } catch (error) {
      setSnackbarMsg("Error updating profile.");
      setSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const hasChanges = name !== initialName || schoolName !== initialSchoolName;

  return (
    <>
      <Box sx={{ display: "flex", height: "100%", bgcolor: "#f5f5f5" }}>
        <Navigation />
        <Box component="main" sx={{ flexGrow: 1, p: 4 }}>
          {snackbarOpen && (
            <SnackbarComponent
              snackbarOpen={snackbarOpen}
              snackbarMsg={snackbarMsg}
              severity={severity}
              handleSnackbarClose={handleSnackbarClose}
            />
          )}
          <Paper elevation={3} sx={{ maxWidth: 600, mx: "auto", p: 4 }}>
            <Grid container direction="column" alignItems="center" spacing={3}>
              <Grid item>
                <Avatar sx={{ width: 120, height: 120 }} />
              </Grid>
              <Grid item>
                <Typography variant="h5" color="primary">
                  {currentUser.email}
                </Typography>
              </Grid>
              {/* <Grid item>
                <Typography variant="h5" color="primary">
                  {schoolName}
                </Typography>
              </Grid> */}

              <Grid item width="100%">
                {editing ? (
                  <TextField
                    fullWidth
                    label="Full Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                ) : (
                  <Typography variant="subtitle1">
                    <strong>Name:</strong> {name || "Not set"}
                  </Typography>
                )}
              </Grid>

              <Grid item width="100%">
                {editing ? (
                  <FormControl fullWidth>
                    <InputLabel>Select School</InputLabel>
                    <Select
                      value={schoolName}
                      label="Select School"
                      onChange={(e) => setSchoolName(e.target.value)}
                    >
                      {SCHOOL_OPTIONS.map((school) => (
                        <MenuItem key={school} value={school}>
                          {school}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <Typography variant="subtitle1">
                    <strong>School Name:</strong> {schoolName || "Not set"}
                  </Typography>
                )}
              </Grid>

              <Grid item>
                {editing ? (
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Button
                      variant="contained"
                      onClick={handleUpdate}
                      disabled={!hasChanges || !name || !schoolName}
                    >
                      Save
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setEditing(false);
                        setName(initialName);
                        setSchoolName(initialSchoolName);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                ) : (
                  <Button
                    variant="outlined"
                    onClick={() => setEditing(true)}
                  >
                    Edit Profile
                  </Button>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default StudentProfile;
